export const BOARD_REQUEST_RETRY_DELAYS_MS = [5_000, 8_000] as const

type BoardRequestRetry = {
  attempt: number
  replied: boolean
  boardOpen: boolean
  assembled: boolean
  closed: boolean
}

export function shouldRetryBoardRequest({
  attempt,
  assembled,
  closed,
}: BoardRequestRetry): boolean {
  return attempt < BOARD_REQUEST_RETRY_DELAYS_MS.length && !assembled && !closed
}

export function nextBoardRequestDelay(attempt: number): number | null {
  return BOARD_REQUEST_RETRY_DELAYS_MS[attempt] ?? null
}
